<template>
  <div class="vs-search vs-has-eyebrow">
    <label
      class="vs-label vs-label-eyebrow"
      :class="{ 'vs-has-focus': inputElFocus }"
      :dir="direction"
      :for="'search_input_' + computedId"
    >
      {{ label }}
    </label>
    <div
      class="vs-input-group vs-inline-group vs-eyebrow-group"
      :dir="direction"
    >
      <input
        :id="'search_input_' + computedId"
        class="vs-input"
        type="text"
        @blur="onblur_input()"
        @focus="onfocus_input()"
        @keyup="onkeyup_input($event)"
      >
      <button
        v-if="clearButtonLabel && showInputClearEl"
        class="vs-btn vs-btn-clear-icon"
        @click="onclick_clear()"
      >
        <span class="visa-icon visa-icon-close-md">
          <span class="vs-sr-only">
            {{ clearButtonLabel }}
          </span>
        </span>
      </button>
      <button
        v-if="submitButtonLabel && submitButtonIcon == 'true'"
        class="vs-btn vs-btn-submit-icon"
        :class="{ 'vs-search-btn-focus': showInputClearEl }"
        @click="onclick_submit()"
      >
        <span class="visa-icon visa-icon-search-md">
          <span class="vs-sr-only">{{ submitButtonLabel }}</span>
        </span>
      </button>
      <button
        v-if="submitButtonLabel && submitButtonIcon == ''"
        class="vs-btn vs-btn-primary vs-btn-submit"
        @click="onclick_submit()"
      >
        {{ submitButtonLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import { setDirection } from '@/helpers/direction';
import { generateId } from '@/helpers/generate-id';

export default {
  name: 'VsSearchInput',
  props: {
    id: { type: String, default: '' },
    label: { type: String, default: '' },
    direction: { type: String, default: setDirection() },
    clearButtonLabel: { type: String, default: '' },
    submitButtonLabel: { type: String, default: '' },
    submitButtonIcon: { type: String, default: '' },
  },
  data() {
    return {
      inputEl: null,
      inputElFocus: false,
      showInputClearEl: false,
      computedId: '',
    };
  },
  mounted() {
    this.computedId = this.id.length ? this.id : generateId().toString();
    this.inputEl = this.$el.querySelector('input');
  },
  methods: {
    onkeyup_input(e) {
      const key = e.code;

      this.showInputClearEl = this.inputEl.value ? true : false;

      if (key === 'Enter') {
        e.preventDefault();

        this.onclick_submit();
      }
    },
    onblur_input() {
      if (!(document.activeElement === this.inputEl)) {
        this.inputElFocus = this.inputEl.value ? true : false;
      }
    },
    onfocus_input() {
      this.inputElFocus = true;
    },
    onclick_clear() {
      this.inputEl.value = '';
      this.inputElFocus = true;
      this.showInputClearEl = false;
      this.inputEl.focus();

      new CustomEvent('clear_button_search');
      this.$emit('clear_button_search');
    },
    onclick_submit() {
      const detail = {
        searchQuery: this.inputEl.value,
        searchObject: this.inputEl.dataset.selected,
      };

      new CustomEvent('submit_button_search');
      this.$emit('submit_button_search', detail);
    },
    resetValues(content) {
      if (content && content.length) {
        this.inputEl.value = content;
      } else {
        this.inputEl.value = '';
        this.inputElFocus = false;
      }

      this.showInputClearEl = this.inputEl.value ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './searchInput';
@import '@/styles/core/types/types';
@import '@/styles/buttons/buttons';
@import '@/styles/input';
@import '@/styles/label';
@import '@/styles/accessibility';
</style>
